// A jegytípus neve az árral zárójelben ("Támogatói jegy (2000 Ft)"); ingyenes jegynél csak a név.
// Ott használjuk, ahol a vendég a jegytípust választja (vendég hozzáadása); a darabszámos jegylistában az ár külön oszlopban van.
export function jegytipusNevArral(jegytipus) {
    const ar = Number(jegytipus.Arnetto);
    return ar > 0 ? jegytipus.Nev + ' (' + ar + ' Ft)' : jegytipus.Nev;
}
